// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__lk4R6","sidebar-container":"Sidebar_sidebar-container__KNlg0"};